import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { inquiryPalette } from './utils/transactionTypes';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import awsConfig from './aws-config';

// CSS to auto-click skip on the verify user screen
// This hides the verify form and auto-triggers the skip button
const style = document.createElement('style');
style.textContent = `
  /* Hide the verify user form completely */
  [data-amplify-authenticator] [data-amplify-router-content="verifyUser"],
  [data-amplify-authenticator][data-amplify-router-content="verifyUser"] form {
    display: none !important;
  }
`;
document.head.appendChild(style);

// Auto-skip verify user screen by clicking the skip button
const observer = new MutationObserver(() => {
  const skipButton = document.querySelector('[data-amplify-authenticator] button[type="button"]');
  const verifyForm = document.querySelector('[data-amplify-authenticator] [data-amplify-router-content="verifyUser"]');

  if (verifyForm || (skipButton && skipButton.textContent.toLowerCase().includes('skip'))) {
    if (skipButton) {
      console.log('Auto-skipping verify user screen');
      skipButton.click();
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// Configure Amplify with custom settings
Amplify.configure({
  ...awsConfig,
  Auth: {
    ...awsConfig.Auth,
    // Disable automatic token refresh to prevent unexpected logouts
    // We'll handle session management manually in AuthContext
    autoSignIn: {
      enabled: false
    }
  }
});

// Create Material-UI theme
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    inquiry: inquiryPalette, // balance-inquiry chips (purple); see utils/transactionTypes.js
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);